import {createSelector} from 'reselect';
import {getOrderTotalNumeric} from '../../OrderSummarySelectors';
import {getSettings} from '../../selectors';
import getNewpayScriptLoadFailure from './getNewpayScriptLoadFailure';
import isNewpayAvailable from './isNewpayAvailable';

export const getShouldDisableNewpay = createSelector(
  [getSettings, getOrderTotalNumeric, getNewpayScriptLoadFailure, isNewpayAvailable],
  (settings, orderTotal, scriptLoadFailure, newpayAvailable) => !!(orderTotal < settings?.newpay_min_value
    || orderTotal > settings?.newpay_max_value || scriptLoadFailure || !newpayAvailable),
);

export default getShouldDisableNewpay;
